import React from 'react'
import {
    PlayButton,
    PlayButtonProps,
} from '../../../../buttons/PlayButton/PlayButton'
import { StyledPlayOverlay } from '../../../../content/Video/components/PlayOverlay/PlayOverlay.styled'
import { playOverlayClassName } from './PlayOverlay.common'

export interface PlayOverlayProps extends PlayButtonProps {
    play: () => void
}

export const PlayOverlay: React.FC<PlayOverlayProps> = (props) => (
    <StyledPlayOverlay className={playOverlayClassName} onClick={props.play}>
        <PlayButton
            onClick={props.play}
            isCentered={props.isCentered}
            isInversed={props.isInversed}
            isSmall={props.isSmall}
        />
    </StyledPlayOverlay>
)
PlayOverlay.displayName = 'PlayOverlay'
